<template>
  <v-toolbar extended flat id="topBar" :height=60 :extension-height=40 app>
    <v-container fluid fill-height grid-list-md style="padding:5px;">
      <v-layout row>
        <img height="50" :src=logo alt="">
        <div style="color:white;margin:10px;padding:5px;font-size:36px;font-weight:bold;display:flex;justify-content:center;align-items:center;">WiDE Online</div>
        <v-spacer></v-spacer>
        <div style="margin:0px 10px 0px 10px;">
          <div style="color:white;display:flex;justify-content:flex-end;align-items:center;height:50%;">{{ userName }}</div>
          <div style="color:rgb(218,218,218);display:flex;justify-content:flex-end;align-items:center;height:50%;">{{ companyName }}</div>
        </div>
        <v-avatar v-on:click="goToSettings()">
          <img style="width:40px;height:40px;" :src="user" alt="">
        </v-avatar>
        <v-menu bottom left offset-y>
          <template v-slot:activator="{ on }">
            <v-avatar tile="true" v-on="on">
              <img style="width:24px;height:24px;" :src="burger" alt="">
            </v-avatar>
          </template>
          <v-list>
            <v-list-tile
                v-for="item in burgerItems" :key="item" v-on:click="menuSelect(item)">
              <v-list-tile-title>{{ item }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-layout>
    </v-container>
  </v-toolbar>
</template>

<script>

// import AlertMenu     from "./AlertMenu"
import {store} from "../main.js"

export default {
  name: "Topbar",
  components: {
    // AlertMenu
  },
  props: {
    userName: String,
    companyName: String
  },
  data: function () {
    return {
      logo: require('../assets/WiDE_Logo_Light.png'),
      burger: require('../assets/burger_active_dark.png'),
      notif: require('../assets/notifications.png'),
      ticket: require('../assets/ticket.png'),
      user: require('../assets/estLogo.png'),
      burgerItems: ['Users', 'Logout'],//[ 'Report','Settings','Logout'],
      showAlert: false,
      alertMenu: false,
      X: 0,
      Y: 0
    }
  },
  methods: {
    menuSelect(menuItem) {
      switch (menuItem) {
        case "Settings":
          this.$router.push({path: '/user-settings'});
          break;
        case "Users":
          this.$router.push({path: '/users'})
          break;
        case "Report":
          this.$router.push({path: '/report'})
          break;
        default:
          store.userLogged = false;
          window.$cookies.remove('user');
          this.$router.push({path: '/login'});
      }
    },
  },
  created() {
    if (typeof store.userProfile.logo != 'undefined' && store.userProfile.logo) {
      this.user = require('../assets/' + store.userProfile.logo);
    }
  },
  mounted() {
    let superAdmin = store.userProfile.roles.filter((item) => {
      return item.toLowerCase().indexOf('super') > -1 && item.toLowerCase().indexOf('admin') > -1
    }).length > 0;

    if (! superAdmin) {
      this.burgerItems = this.burgerItems.filter((item) => {
        return item != 'Users';
      });
    }
  }
}
</script>

<style scoped>
#topBar {
  background-color: rgb(144, 170, 218);
  padding: 0px;
}


</style>
